import React from "react";

export default function BucketsTableMaxCoolentOut(props) {
  let { data } = props;
  // console.log("props---out",props);

  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.Max_BCS_Coolant_Out.value)} </td>
        </tr>)
      })}
    </>
  );
}

